module.exports = __webpack_public_path__ + "img/product-0.51dc5447.svg";